import { cn } from '@/lib/utils'
import { useInvestigationStore } from '@/lib/stores/investigation'
import useInvestigationAction from '@/lib/api/investigations/action'
import { useCurrentInvestigation } from '@/hooks/useCurrentInvestigation'
import { useGoNextInvestigation } from '@/hooks/useGoNextInvestigation'
import { useGetMessagingTemplate } from '@/hooks/useGetMessagingTemplate'
import InvestigationTemplatePreview from './template-preview'
import { getInvestigationLink } from '@/utils/investigations'
import { useUser } from '@clerk/clerk-react'
import { X } from 'lucide-react'

const InvestigationRetest = () => {
  const { setSidebarView, setContactMessage } = useInvestigationStore()

  const goNextInvestigation = useGoNextInvestigation()
  const action = useInvestigationAction()
  const investigation = useCurrentInvestigation(true)
  const { user } = useUser()

  const {
    data: retestTemplate,
    isLoading,
    error
  } = useGetMessagingTemplate({
    vendorHash: investigation.data?.vendorHash ?? '',
    templateName: 'conversation-retest',
    data: {
      patientName: investigation.data?.patient.firstName ?? '',
      prescriberName: user?.fullName ?? '',
      testKitLink: investigation.data && getInvestigationLink(investigation.data).retest
    },
    enabled: Boolean(investigation?.data)
  })

  const data = investigation?.data

  const isDisabled = action.isPending || !retestTemplate

  if (!data) return null

  return (
    <div className='sticky top-[88px] max-w-[300px] h-fit flex min-w-[25vw] flex-col rounded-2xl border border-custom-neutral-200 shadow-[0px_0px_1px_0px_rgba(113,128,150,0.04),0px_4px_8px_0px_rgba(113,128,150,0.08)]'>
      <div className='p-6 mb-8'>
        <div className='mb-2 flex justify-between items-center'>
          <p className='text-custom-neutral-600 text-xl font-semibold leading-[133.4%]'>Contact</p>
          <X
            className='w-6 h-6 text-custom-neutral-600 cursor-pointer'
            onClick={() => setSidebarView('navigation-menu')}
          />
        </div>
        <p className='text-custom-neutral-500 text-sm leading-[170%]'>
          Notify the customer support team they need to contact the patient.
        </p>
      </div>
      <div className='px-6 pb-6'>
        <InvestigationTemplatePreview template={retestTemplate} isLoading={isLoading} error={Boolean(error)} />
        <button
          type='button'
          disabled={isDisabled}
          onClick={() => {
            if (!investigation.data) return

            action.mutate({
              id: investigation.data.id,
              action: 'contact',
              message: retestTemplate ?? ''
            })

            goNextInvestigation()
          }}
          className={cn(
            'flex justify-center items-center gap-2 mb-4 h-14 rounded-2xl bg-[#153CB7] text-white text-sm font-semibold leading-[170%] w-full transition-all duration-200 ease-in-out',
            isDisabled && 'opacity-50 cursor-not-allowed',
            action.isPending && 'cursor-wait opacity-70'
          )}
        >
          Send
        </button>
        <button
          type='button'
          onClick={() => {
            setSidebarView('navigation-menu')
            setContactMessage('')
          }}
          className='flex h-14 w-full color-[#1D1D1D] items-center justify-center gap-4 rounded-2xl border border-custom-neutral-200 bg-white px-6 text-custom-neutral-600 text-sm font-semibold  hover:bg-custom-neutral-200 transition-colors duration-200
        leading-[170%]'
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default InvestigationRetest
